import RubricBanks from './rubric-banks.js';

export default RubricBanks;
